/**
 * TIMELINE OPERACIONAL
 * Fonte: /api/dashboard/comunicacaoLogs.php
 */
import React, { useEffect, useState } from 'react';
import { Loader2, Activity } from 'lucide-react';

export default function TimelineOperacional() {
  const [logs, setLogs]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/dashboard/comunicacaoLogs.php', { credentials: 'include' })
      .then(r => r.json())
      .then(d => { if (d.success) setLogs(d.logs || []); })
      .catch(err => console.error('[Timeline]', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bg-[#0A0F1E] border border-white/[0.06] rounded-2xl p-6 flex justify-center">
        <Loader2 className="animate-spin text-blue-400" size={20} />
      </div>
    );
  }

  return (
    <div className="bg-[#0A0F1E] border border-white/[0.06] rounded-2xl p-6">

      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-8 rounded-lg bg-blue-500/10 border border-blue-500/20 flex items-center justify-center">
          <Activity size={14} className="text-blue-400" />
        </div>
        <div>
          <h3 className="text-[10px] font-bold text-blue-400 uppercase tracking-[0.2em]">
            Timeline Operacional
          </h3>
          <p className="text-[9px] text-slate-500 uppercase tracking-wider mt-0.5">
            Eventos recentes
          </p>
        </div>
      </div>

      {logs.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-slate-500 text-xs">Nenhum evento registrado.</p>
        </div>
      ) : (
        <div className="space-y-3 max-h-[280px] overflow-y-auto pr-1">
          {logs.map(log => (
            <div
              key={log.id}
              className="flex items-start gap-3 pl-3 border-l-2 border-blue-500/30"
            >
              <div className="min-w-0 flex-1">
                <p className="text-slate-400 text-[10px]">
                  {new Date(log.criado_em).toLocaleString('pt-BR')}
                </p>
                <p className="text-white text-xs font-bold mt-0.5">
                  {log.meio || '—'} — {log.tentativa || 0}ª tentativa
                </p>
                {log.codigo_mh && (
                  <p className="text-slate-500 text-[10px] mt-0.5">
                    {log.codigo_mh}
                  </p>
                )}
              </div>
              <span className={`text-[9px] font-bold uppercase tracking-widest shrink-0 ${
                log.status === 'ENVIADO' ? 'text-emerald-400' :
                log.status === 'ERRO'    ? 'text-red-400'     :
                'text-slate-500'
              }`}>
                {log.status || '—'}
              </span>
            </div>
          ))}
        </div>
      )}

    </div>
  );
}